import { ETSY_URL, CATEGORIES, trackEtsy } from "../data/site";
import { ArrowUpRight } from "lucide-react";

export default function Collections() {
  return (
    <section
      id="collections"
      data-testid="collections-section"
      className="relative py-24 md:py-36 px-6 md:px-12 lg:px-20 bg-[#0B0B0B]"
    >
      {/* Top header */}
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16 reveal">
        <div>
          <span className="text-[11px] tracking-[0.42em] uppercase text-[#D4AF37]">
            № 03 — Featured Collections
          </span>
          <h2 className="mt-5 font-serif-display text-[36px] sm:text-5xl md:text-6xl leading-[1.05] tracking-tight text-white max-w-2xl">
            Five worlds, <br />
            <span className="italic text-white/80">one heritage.</span>
          </h2>
        </div>
        <p className="max-w-md text-[15px] leading-[1.8] text-white/65 font-light">
          A curation of the most loved pieces in our Etsy shop — explore each
          category and bring a story home.
        </p>
      </div>

      {/* Bento grid */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-12 gap-5 md:gap-6">
        {CATEGORIES.map((c, idx) => {
          const spanByIdx = [
            "md:col-span-7 md:row-span-2",
            "md:col-span-5",
            "md:col-span-5",
            "md:col-span-4",
            "md:col-span-3",
          ];
          return (
          <a
            key={c.id}
            href={ETSY_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackEtsy("heritage_collection_card", { collection_id: c.id })}
            data-testid={`collection-card-${c.id}`}
            className={`card-sheen group block relative ${spanByIdx[idx] || "md:col-span-6"}`}
          >
            <div
              className={`relative overflow-hidden ${
                idx === 0 ? "aspect-[4/5] md:aspect-[7/9]" : "aspect-[4/5]"
              }`}
            >
              <img
                src={c.image}
                alt={c.name}
                loading="lazy"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0B0B0B] via-[#0B0B0B]/40 to-transparent" />

              {/* Index */}
              <div className="absolute top-5 left-5 z-10 flex items-center gap-3">
                <span className="index-num">0{idx + 1}</span>
                <span className="h-px w-8 bg-[#D4AF37]/50" />
              </div>

              {/* Hover arrow */}
              <div className="absolute top-5 right-5 z-10 w-10 h-10 border border-[#D4AF37]/40 flex items-center justify-center text-[#D4AF37] opacity-0 group-hover:opacity-100 transition-all duration-500 translate-y-2 group-hover:translate-y-0">
                <ArrowUpRight className="w-4 h-4" />
              </div>

              {/* Bottom text */}
              <div className="absolute left-0 right-0 bottom-0 p-6 md:p-8 z-10">
                <p className="text-[10px] tracking-[0.42em] uppercase text-[#D4AF37] mb-2">
                  {c.tagline}
                </p>
                <h3 className="font-serif-display text-[24px] md:text-3xl lg:text-4xl text-white leading-tight">
                  {c.name}
                </h3>
                <p className="mt-3 text-[13px] leading-relaxed text-white/65 max-w-md">
                  {c.description}
                </p>
                <div className="mt-5 inline-flex items-center gap-2 text-[10px] tracking-[0.32em] uppercase text-white/80 group-hover:text-[#D4AF37] transition-colors">
                  View on Etsy
                  <ArrowUpRight className="w-3.5 h-3.5 transition-transform duration-500 group-hover:translate-x-1 group-hover:-translate-y-0.5" />
                </div>
              </div>
            </div>
          </a>
          );
        })}
      </div>
    </section>
  );
}
